import { useEffect } from 'react';
import usePrevious from './usePrevious';

export const useShowMobileContractLoader = (
  loadingMobileContractData,
  setShowMobileContractDataLoader,
) => {
  const previousLoadingMobileContractData = usePrevious(loadingMobileContractData);

  useEffect(() => {
    if (!loadingMobileContractData && previousLoadingMobileContractData) {
      setShowMobileContractDataLoader(false);
    }
  }, [
    loadingMobileContractData,
    previousLoadingMobileContractData,
    setShowMobileContractDataLoader,
  ]);
};
